import FormattedMessage from 'I18n/components/FormattedMessage';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalUserType } from '../../types';
import { UnreachableI18nCaseError } from '../../utils/i18nUtils';
import PendingApprovalButtonI18nHeadingNonParticipant from './PendingApprovalButtonI18nHeadingNonParticipant';
import { jsx as _jsx } from "react/jsx-runtime";
function PendingApprovalButtonI18nHeading() {
  const approval = useApprovalContext();
  const {
    currentUserType,
    stepCount,
    approvedCount
  } = approval.meta;
  switch (currentUserType) {
    case ApprovalUserType.REQUESTER:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipHeadingText.REQUESTER"
        });
      }
    case ApprovalUserType.APPROVER:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.PendingApprovalTooltipHeadingText.APPROVER",
          options: {
            count: stepCount,
            approvedCount
          }
        });
      }
    case ApprovalUserType.NON_PARTICIPANT:
      {
        return /*#__PURE__*/_jsx(PendingApprovalButtonI18nHeadingNonParticipant, {});
      }
    default:
      throw new UnreachableI18nCaseError(currentUserType);
  }
}
export default PendingApprovalButtonI18nHeading;